// extracted by mini-css-extract-plugin
export default {"mainWrapper":"numberOfPartners_mainWrapper__DJqJq","rowWrapper":"numberOfPartners_rowWrapper__VpkQ8"};